import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiStatusDetailTab extends Layout {
    panelStatusTab: Panel;
    sourceEdistatus: DataSource;
    textboxAppointmentDate: Textbox;
    textboxBatch: Textbox;
    textboxDelayCode: Textbox;
    textboxEta: Textbox;
    textboxEventType: Textbox;
    textboxReadyToSend: Textbox;
    textboxShipMatchDescr: Textbox;
    textboxShipMatchType: Textbox;
    textboxSourceRecordType: Textbox;
    textboxStatusCode: Textbox;
    textboxStatusDate: Textbox;
    textboxStopDescription: Textbox;
    textboxTimezoneId: Textbox;
}
